import React, { FunctionComponent } from 'react'

export interface Props {
  color?: string
  height?: string
  width?: string
  colorClass?: string
}

export const RefiMeNow: FunctionComponent<Props> = ({
  color = '#92a0ab',
  height = '74px',
  width = '74px',
  colorClass,
}) => (
  <svg width={width} height={height} viewBox="0 0 74 74">
    <title>RefiMeNowIcon</title>
    <g
      id="RefiMeSoon"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        id="MissionControl-Hub"
        transform="translate(-595.000000, -851.000000)"
        stroke={color}
        className={colorClass}
        strokeWidth="5"
      >
        <g id="Save" transform="translate(597.000000, 853.000000)">
          <polyline
            id="Stroke-1"
            points="35.0410499 19.4760973 35.0410499 41.8818335 25.1933675 32.5213726 35.0410499 41.8818335 44.8887324 32.5213726"
          />
          <polyline
            id="Stroke-2"
            points="17.1374341 28.9469091 17.1374341 48.3551037 52.9433752 48.3551037 52.9433752 28.9469091"
          />
          <path
            d="M69.4543764,35.0407273 C69.4543764,54.0455928 54.0472061,69.4527631 35.0423406,69.4527631 C16.0342484,69.4527631 0.627078105,54.0455928 0.627078105,35.0407273 C0.627078105,16.0358617 16.0342484,0.628691421 35.0423406,0.628691421 C54.0472061,0.628691421 69.4543764,16.0358617 69.4543764,35.0407273 Z"
            id="Stroke-3"
          />
        </g>
      </g>
    </g>
  </svg>
)
